<template>
    <div v-show="this.items.length !== 0">
        <warning>
                <div class="flex justify-between">
                    <div>Es liegt eine Anfrage für mindestens einen Konferenzraum vor.</div>
                    <div class="ml-2">
                        <button-white><a href="/admin/pages/conference_rooms">Anfragen anzeigen</a></button-white>
                    </div>
                </div>

        </warning>
    </div>
</template>

<script>
import Warning from "./UI/Warning";
import ButtonWhite from "./UI/ButtonWhite.vue"

export default {
    name: "ConferenceRoomRequestWarning",
    components: {Warning, ButtonWhite},

    data: () => ({
        items: [],
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            window.axios.get('/admin/conference_room_bookings/requests').then(response => {
                this.items = response.data.data;
            })
        },
    }
}
</script>

<style scoped>

</style>
